// api
import { fetchApi } from '@/api'
// actions
const restaurantProductsSubCategoriesAll = (context) => {
  let url = 'inventory/products/indexRestaurantSubcategories'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_SUBCATEGORIES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsSubCategoriesForm = (context) => {
  let url = 'inventory/products/subcategories/CrearSUB'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_SUBCATEGORIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsSubCategoriesShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/products/subcategories/' + obj.id + '/editSub'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_SUBCATEGORIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsSubCategoriesCreate = (context, payload) => {
  let url = 'inventory/products/subcategories'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_SUBCATEGORIES_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsSubCategoriesUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/subcategories/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_SUBCATEGORIES_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsSubCategoriesDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/subcategories/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_SUBCATEGORIES_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsSubcategories = (context, payloadId) => {
  let obj = JSON.parse(payloadId)
  let url = 'inventory/products/categories/' +  obj + '/subs'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_SUBCATEGORIES', response)
      let json = response.data
      var s = document.querySelector('[name=idSubCategory]')
      s.innerHTML = ''
      s.options[s.options.length] = new Option('Seleccione una opcion', null)
      for (var i = 0; i < json.length; i++) {
        s.options[s.options.length] = new Option(json[i].name, json[i].id)
      }
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsSubcategoriesAll = (context, payloadId) => {
alert('1')
  let obj = JSON.parse(payloadId)
  let url = 'inventory/products/categories/'  +  obj.id +  '/subs'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_SUBCATEGORIES', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsFilterSubCategories = (context, payloadId) => {
  let url = 'inventory/products/subcategories/' + payloadId + '/products'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_FILTER_SUBCATEGORIES', response)
      let json = response.data
      var s = document.querySelector('[name=idSubCategory]')
      s.innerHTML = ''
      s.options[s.options.length] = new Option('Seleccione una opcion', null)
      for (var i = 0; i < json.length; i++) {
        s.options[s.options.length] = new Option(json[i].name, json[i].id)
      }
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsFilterSubCategoriesAll = (context, payloadId) => {
  let url = 'inventory/products/subcategories/' + payloadId + '/products'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_FILTER_SUBCATEGORIES', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  restaurantProductsSubCategoriesAll,
  restaurantProductsSubCategoriesForm,
  restaurantProductsSubCategoriesShow,
  restaurantProductsSubCategoriesCreate,
  restaurantProductsSubCategoriesUpdate,
  restaurantProductsSubCategoriesDelete,
  restaurantProductsSubcategories,
  restaurantProductsSubcategoriesAll,
  restaurantProductsFilterSubCategories,
  restaurantProductsFilterSubCategoriesAll
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/products/subcategories/actions.js